'use strict';

(function () {
  var locale = document.documentElement.lang || 'en-US';
  var activeCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  var routes = window.themeRoutes || {
    cart: '/cart.js',
    cartAdd: '/cart/add.js',
    cartChange: '/cart/change.js',
    allProducts: '/collections/all'
  };

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency || activeCurrency
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function requestJSON(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) {
          throw new Error(data.description || data.message || 'Request failed');
        }
        return data;
      });
    });
  }

  function showStatus(message, isError) {
    var status = document.getElementById('theme-status');
    if (!status) return;
    status.textContent = message;
    status.classList.toggle('is-error', Boolean(isError));
    status.classList.add('is-visible');
    window.clearTimeout(showStatus.timeout);
    showStatus.timeout = window.setTimeout(function () {
      status.classList.remove('is-visible');
    }, 4500);
  }

  /* Announcement bar */
  (function () {
    var messages = document.querySelectorAll('.ann-msg');
    var prevBtn = document.getElementById('ann-prev');
    var nextBtn = document.getElementById('ann-next');
    var bar = document.querySelector('.announcement-bar');
    var index = 0;
    var timer;
    if (!messages.length) return;

    function show(nextIndex) {
      index = (nextIndex + messages.length) % messages.length;
      messages.forEach(function (message, messageIndex) {
        var isCurrent = messageIndex === index;
        message.style.opacity = isCurrent ? '1' : '0';
        message.style.position = isCurrent ? 'relative' : 'absolute';
        message.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
      });
    }

    function start() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      window.clearInterval(timer);
      timer = window.setInterval(function () { show(index + 1); }, 5000);
    }

    show(0);
    start();
    if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); start(); });
    if (bar) {
      bar.addEventListener('mouseenter', function () { window.clearInterval(timer); });
      bar.addEventListener('mouseleave', start);
      bar.addEventListener('focusin', function () { window.clearInterval(timer); });
      bar.addEventListener('focusout', start);
    }
  })();

  /* Header */
  (function () {
    var header = document.querySelector('.site-header');
    if (!header) return;
    function update() {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
  })();

  /* Mobile menu */
  (function () {
    var openButton = document.getElementById('mobile-menu-open');
    var closeButton = document.getElementById('mobile-menu-close');
    var overlay = document.getElementById('mobile-overlay');
    var background = document.getElementById('mobile-overlay-bg');
    var menu = overlay && overlay.querySelector('.mobile-menu');
    var previousFocus;
    if (!openButton || !overlay || !menu) return;

    function openMenu() {
      previousFocus = document.activeElement;
      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('is-locked');
      if (closeButton) closeButton.focus();
    }

    function closeMenu() {
      overlay.classList.remove('open');
      overlay.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('is-locked');
      if (previousFocus && previousFocus.focus) previousFocus.focus();
    }

    openButton.addEventListener('click', openMenu);
    if (closeButton) closeButton.addEventListener('click', closeMenu);
    if (background) background.addEventListener('click', closeMenu);
    overlay.addEventListener('click', function (event) {
      if (event.target.closest('a')) closeMenu();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && overlay.classList.contains('open')) closeMenu();
    });
  })();

  /* Cart drawer */
  (function () {
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.getElementById('cart-overlay');
    var closeButton = document.getElementById('cart-drawer-close');
    var checkoutButton = document.getElementById('cart-drawer-checkout');
    var itemsElement = document.getElementById('cart-drawer-items');
    var totalElement = document.getElementById('cart-drawer-total');
    var statusElement = document.getElementById('cart-drawer-status');
    var previousFocus;
    if (!drawer || !itemsElement) return;

    function setCartButtonsExpanded(expanded) {
      document.querySelectorAll('[data-open-cart]').forEach(function (button) {
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    function updateCartCount(count) {
      var countElement = document.getElementById('cart-count');
      if (countElement) {
        countElement.textContent = count > 9 ? '9+' : String(count);
        countElement.classList.toggle('is-empty', count === 0);
      }
      document.querySelectorAll('[data-open-cart]').forEach(function (button) {
        button.setAttribute('aria-label', 'Open cart, ' + count + (count === 1 ? ' item' : ' items'));
      });
    }

    function announce(message) {
      if (statusElement) statusElement.textContent = message;
    }

    function createQuantityButton(label, text, key, quantity) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'cart-drawer__qty-btn';
      button.setAttribute('aria-label', label);
      button.dataset.cartKey = key;
      button.dataset.cartQuantity = String(quantity);
      button.textContent = text;
      return button;
    }

    function renderCart(cart) {
      itemsElement.replaceChildren();
      updateCartCount(cart.item_count);
      if (totalElement) totalElement.textContent = formatMoney(cart.total_price, cart.currency);

      if (!cart.item_count) {
        var empty = document.createElement('div');
        empty.className = 'cart-drawer__empty';
        var emptyTitle = document.createElement('strong');
        emptyTitle.textContent = 'Your cart is ready for the next upgrade.';
        var emptyLink = document.createElement('a');
        emptyLink.href = routes.allProducts;
        emptyLink.className = 'btn btn--primary';
        emptyLink.textContent = 'Shop All Products';
        empty.append(emptyTitle, emptyLink);
        itemsElement.appendChild(empty);
        if (checkoutButton) checkoutButton.hidden = true;
        announce('Your cart is empty.');
        return;
      }

      if (checkoutButton) checkoutButton.hidden = false;

      cart.items.forEach(function (item) {
        var row = document.createElement('article');
        row.className = 'cart-drawer__item';

        var imageLink = document.createElement('a');
        imageLink.className = 'cart-drawer__item-image';
        imageLink.href = item.url;
        imageLink.setAttribute('aria-label', item.product_title);
        if (item.image) {
          var image = document.createElement('img');
          image.src = item.image;
          image.alt = item.featured_image && item.featured_image.alt ? item.featured_image.alt : '';
          image.width = 144;
          image.height = 144;
          image.loading = 'lazy';
          imageLink.appendChild(image);
        }

        var details = document.createElement('div');
        var title = document.createElement('a');
        title.className = 'cart-drawer__item-title';
        title.href = item.url;
        title.textContent = item.product_title;
        details.appendChild(title);

        if (item.variant_title && item.variant_title !== 'Default Title') {
          var variant = document.createElement('div');
          variant.className = 'cart-drawer__item-variant';
          variant.textContent = item.variant_title;
          details.appendChild(variant);
        }

        var price = document.createElement('div');
        price.className = 'cart-drawer__item-price';
        price.textContent = formatMoney(item.final_line_price, cart.currency);
        details.appendChild(price);

        var controls = document.createElement('div');
        controls.className = 'cart-drawer__qty';
        controls.appendChild(createQuantityButton('Decrease ' + item.product_title + ' quantity', '−', item.key, Math.max(0, item.quantity - 1)));
        var quantity = document.createElement('span');
        quantity.textContent = String(item.quantity);
        quantity.setAttribute('aria-label', 'Quantity ' + item.quantity);
        controls.appendChild(quantity);
        controls.appendChild(createQuantityButton('Increase ' + item.product_title + ' quantity', '+', item.key, item.quantity + 1));
        details.appendChild(controls);

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'cart-drawer__item-remove';
        remove.dataset.cartKey = item.key;
        remove.dataset.cartQuantity = '0';
        remove.textContent = 'Remove';
        details.appendChild(remove);

        row.append(imageLink, details);
        itemsElement.appendChild(row);
      });
      announce(cart.item_count + (cart.item_count === 1 ? ' item in cart.' : ' items in cart.'));
    }

    function renderError() {
      itemsElement.replaceChildren();
      var error = document.createElement('div');
      error.className = 'cart-drawer__error';
      error.textContent = 'We could not load your cart. Please refresh the page or call 480-322-4626 for help.';
      itemsElement.appendChild(error);
      announce('Cart could not be loaded.');
    }

    function refreshCart() {
      return requestJSON(routes.cart, { headers: { Accept: 'application/json' } })
        .then(renderCart)
        .catch(renderError);
    }

    function updateCartItem(key, quantity, button) {
      if (button) button.disabled = true;
      requestJSON(routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(renderCart)
        .catch(function (error) {
          if (button) button.disabled = false;
          showStatus(error.message + ' Please try again or call 480-322-4626.', true);
        });
    }

    function openCart() {
      previousFocus = document.activeElement;
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) {
        overlay.classList.add('open');
        overlay.setAttribute('aria-hidden', 'false');
      }
      setCartButtonsExpanded(true);
      document.body.classList.add('is-locked');
      refreshCart();
      if (closeButton) closeButton.focus();
    }

    function closeCart() {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) {
        overlay.classList.remove('open');
        overlay.setAttribute('aria-hidden', 'true');
      }
      setCartButtonsExpanded(false);
      document.body.classList.remove('is-locked');
      if (previousFocus && previousFocus.focus) previousFocus.focus();
    }

    document.querySelectorAll('[data-open-cart]').forEach(function (button) {
      button.addEventListener('click', openCart);
    });
    if (closeButton) closeButton.addEventListener('click', closeCart);
    if (overlay) overlay.addEventListener('click', closeCart);
    itemsElement.addEventListener('click', function (event) {
      var button = event.target.closest('[data-cart-key]');
      if (!button) return;
      updateCartItem(button.dataset.cartKey, Number(button.dataset.cartQuantity), button);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('open')) closeCart();
    });

    window.openCartDrawer = openCart;
    window.refreshCart = refreshCart;
  })();

  /* Quick add buttons */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-atc]');
    if (!button) return;
    var variantId = Number(button.getAttribute('data-atc'));
    if (!variantId) return;
    var originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    requestJSON(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function () {
        button.textContent = 'Added';
        if (window.openCartDrawer) window.openCartDrawer();
        window.setTimeout(function () {
          button.disabled = false;
          button.textContent = originalLabel;
        }, 1800);
      })
      .catch(function (error) {
        button.disabled = false;
        button.textContent = originalLabel;
        showStatus(error.message + ' Please try again or call 480-322-4626.', true);
      });
  });

  /* Product forms */
  document.querySelectorAll('.product-form').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      var submitButton = form.querySelector('[name="add"]');
      var message = form.querySelector('[data-product-message]');
      if (!submitButton) return;
      event.preventDefault();
      submitButton.disabled = true;
      submitButton.textContent = 'Adding…';
      if (message) message.textContent = '';

      var data = new FormData(form);
      requestJSON(routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data
      })
        .then(function () {
          submitButton.textContent = 'Added to Cart';
          if (message) message.textContent = 'Added to your cart.';
          if (window.openCartDrawer) window.openCartDrawer();
          window.setTimeout(function () {
            submitButton.disabled = false;
            submitButton.textContent = submitButton.dataset.defaultLabel || 'Add to Cart';
          }, 2000);
        })
        .catch(function (error) {
          submitButton.disabled = false;
          submitButton.textContent = submitButton.dataset.defaultLabel || 'Add to Cart';
          if (message) message.textContent = error.message + ' Please try again or call 480-322-4626.';
          showStatus('Item could not be added. Please try again or call 480-322-4626.', true);
        });
    });
  });

  /* Quantity controls */
  document.querySelectorAll('.product-form__qty').forEach(function (quantityControl) {
    var minus = quantityControl.querySelector('[data-qty-minus]');
    var plus = quantityControl.querySelector('[data-qty-plus]');
    var input = quantityControl.querySelector('.product-form__qty-input');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      input.value = String(Math.max(1, (parseInt(input.value, 10) || 1) - 1));
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = String((parseInt(input.value, 10) || 1) + 1);
    });
  });

  /* Product gallery */
  function activateProductMedia(section, thumbnail) {
    if (!section || !thumbnail) return;
    var mediaId = thumbnail.dataset.mediaId;
    var main = section.querySelector('[data-gallery-main]');
    if (main && mediaId) {
      main.querySelectorAll('.product-gallery__media').forEach(function (media) {
        var active = media.dataset.mediaId === mediaId;
        media.hidden = !active;
        media.classList.toggle('is-active', active);
        if (!active) {
          var video = media.querySelector('video');
          if (video) video.pause();
        }
      });
    }
    section.querySelectorAll('.product-gallery__thumb').forEach(function (item) {
      var active = item === thumbnail;
      item.classList.toggle('active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  document.querySelectorAll('.product-gallery__thumb').forEach(function (thumbnail) {
    thumbnail.addEventListener('click', function () {
      activateProductMedia(thumbnail.closest('[data-product-section]'), thumbnail);
    });
  });
  document.querySelectorAll('.product-gallery').forEach(function (gallery) {
    var main = gallery.querySelector('.product-gallery__main');
    var thumbnails = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__thumb'));
    var touchStartX = 0;
    if (!main || thumbnails.length < 2) return;
    main.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });
    main.addEventListener('touchend', function (event) {
      var distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) < 48) return;
      var currentIndex = thumbnails.findIndex(function (item) { return item.classList.contains('active'); });
      var direction = distance < 0 ? 1 : -1;
      var nextIndex = (currentIndex + direction + thumbnails.length) % thumbnails.length;
      thumbnails[nextIndex].click();
      thumbnails[nextIndex].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }, { passive: true });
  });

  /* Product variants */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var sectionId = section.getAttribute('data-product-section');
    var variantsElement = document.getElementById('ProductVariants-' + sectionId);
    var select = section.querySelector('[data-variant-select]');
    if (!variantsElement || !select) return;
    var variants;
    try {
      variants = JSON.parse(variantsElement.textContent);
    } catch (error) {
      return;
    }

    function updateVariant() {
      var variant = variants.find(function (item) { return String(item.id) === select.value; });
      if (!variant) return;
      var price = document.getElementById('product-price-' + sectionId);
      var compare = document.getElementById('product-compare-' + sectionId);
      var badge = document.getElementById('product-sale-badge-' + sectionId);
      var availability = document.getElementById('product-availability-' + sectionId);
      var sku = document.getElementById('product-sku-' + sectionId);
      var mobilePrice = document.getElementById('mobile-product-price-' + sectionId);
      var addButton = section.querySelector('[data-product-atc]');
      var mobileButton = section.querySelector('[data-mobile-atc]');
      var dynamicCheckout = section.querySelector('[data-dynamic-checkout]');
      var isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      if (price) price.textContent = formatMoney(variant.price);
      if (mobilePrice) mobilePrice.textContent = formatMoney(variant.price);
      if (compare) {
        compare.textContent = isOnSale ? formatMoney(variant.compare_at_price) : '';
        compare.classList.toggle('is-hidden', !isOnSale);
      }
      if (badge) badge.classList.toggle('is-hidden', !isOnSale);
      if (availability) {
        availability.textContent = variant.available ? 'In stock' : 'Sold out';
        availability.classList.toggle('is-available', variant.available);
      }
      if (sku) sku.textContent = variant.sku || 'Not listed';
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      if (mobileButton) {
        mobileButton.disabled = !variant.available;
        mobileButton.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      if (dynamicCheckout) dynamicCheckout.classList.toggle('is-hidden', !variant.available);

      if (variant.featured_image && variant.featured_image.src) {
        var variantImageBase = variant.featured_image.src.split('?')[0];
        var matchingThumb = Array.prototype.slice.call(section.querySelectorAll('.product-gallery__thumb')).find(function (thumbnail) {
          return (thumbnail.dataset.previewSrc || '').split('?')[0] === variantImageBase;
        });
        if (matchingThumb) {
          activateProductMedia(section, matchingThumb);
        } else {
          var activeImage = section.querySelector('.product-gallery__media.is-active img, #main-product-image');
          if (activeImage) {
            activeImage.src = variant.featured_image.src;
            activeImage.srcset = '';
            activeImage.alt = variant.featured_image.alt || activeImage.alt;
          }
        }
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    select.addEventListener('change', updateVariant);
  });

  /* Mobile product add button */
  document.querySelectorAll('[data-mobile-atc]').forEach(function (button) {
    button.addEventListener('click', function () {
      var section = button.closest('[data-product-section]');
      var form = section && section.querySelector('.product-form');
      if (!form) return;
      if (form.requestSubmit) form.requestSubmit();
      else form.querySelector('[name="add"]').click();
    });
  });

  /* Product detail tabs */
  document.querySelectorAll('.product-details').forEach(function (details) {
    var buttons = Array.prototype.slice.call(details.querySelectorAll('.product-tab-btn'));
    var panels = Array.prototype.slice.call(details.querySelectorAll('.product-tab-content'));
    buttons.forEach(function (button, buttonIndex) {
      button.addEventListener('click', function () {
        var target = 'tab-' + button.dataset.tab;
        buttons.forEach(function (item) {
          var active = item === button;
          item.classList.toggle('active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach(function (panel) {
          var active = panel.id === target;
          panel.classList.toggle('active', active);
          panel.hidden = !active;
        });
      });
      button.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var next = (buttonIndex + direction + buttons.length) % buttons.length;
        buttons[next].focus();
        buttons[next].click();
      });
    });
  });

  /* Homepage product tabs */
  document.querySelectorAll('.featured-products').forEach(function (section) {
    var tabs = section.querySelectorAll('.product-tab');
    var panels = section.querySelectorAll('.product-tab-panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab');
        tabs.forEach(function (item) {
          var active = item === tab;
          item.classList.toggle('active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var active = panel.id === 'panel-' + target;
          panel.classList.toggle('active', active);
          panel.hidden = !active;
        });
      });
    });
  });

  /* Collection sorting */
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      if (select.form) select.form.submit();
    });
  });

  /* Customer address forms */
  document.querySelectorAll('select[data-default]').forEach(function (select) {
    if (select.dataset.default) select.value = select.dataset.default;
  });
  document.querySelectorAll('[data-address-delete]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      if (!window.confirm('Delete this saved address?')) event.preventDefault();
    });
  });

  /* Sitewide business contact correction */
  (function () {
    var mapUrl = 'https://www.google.com/maps/search/?api=1&query=6810+E+Avalon+Dr%2C+Scottsdale%2C+AZ+85251';
    var excludedTextParents = 'script, style, noscript, textarea';
    var contactAttributes = ['title', 'aria-label', 'content', 'value'];

    function normalizeContactValue(value) {
      if (!value || typeof value !== 'string') return value;
      return value
        .replace(/7300\s+E(?:ast)?\.?\s+Minnezona\s+Ave(?:nue)?\.?(?:\s*,?\s*(?:#|Suite)\s*1002)?/gi, '6810 E Avalon Dr')
        .replace(/Phoenix\s*,?\s*(?:Arizona|AZ)\s+85014(?:\s*,?\s*(?:United States|USA))?/gi, 'Scottsdale, AZ 85251')
        .replace(/Scottsdale\s*,?\s*(?:Arizona|AZ)\s+85251/gi, 'Scottsdale, AZ 85251')
        .replace(/6810\s+E(?:ast)?\.?\s+Avalon\s+Dr(?:ive)?\.?\s*,?\s*Scottsdale\s*,?\s*(?:Arizona|AZ)\s+85251/gi, '6810 E Avalon Dr, Scottsdale, AZ 85251')
        .replace(/(?:\+?1[\s.-]*)?\(?602\)?[\s.-]*492[\s.-]*3801/g, '480-322-4626');
    }

    function normalizeAttribute(element, attribute) {
      if (!element.hasAttribute(attribute)) return;
      var current = element.getAttribute(attribute);
      var next = normalizeContactValue(current);
      if (next !== current) element.setAttribute(attribute, next);
    }

    function normalizeElement(element) {
      if (!element || element.nodeType !== 1) return;
      contactAttributes.forEach(function (attribute) {
        normalizeAttribute(element, attribute);
      });
      if (element.tagName === 'A' && element.hasAttribute('href')) {
        var href = element.getAttribute('href');
        var decodedHref = href;
        try { decodedHref = decodeURIComponent(href); } catch (error) {}
        if (/minnezona/i.test(decodedHref)) {
          element.setAttribute('href', mapUrl);
        } else {
          normalizeAttribute(element, 'href');
        }
      }
    }

    function normalizeTextNode(node) {
      if (!node || node.nodeType !== 3) return;
      if (node.parentElement && node.parentElement.closest(excludedTextParents)) return;
      var next = normalizeContactValue(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    }

    function normalizeContactDetails(root) {
      if (!root) return;
      if (root.nodeType === 3) {
        normalizeTextNode(root);
        return;
      }
      if (root.nodeType !== 1) return;
      normalizeElement(root);
      root.querySelectorAll('*').forEach(normalizeElement);
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) normalizeTextNode(walker.currentNode);
    }

    normalizeContactDetails(document.documentElement);

    if (window.MutationObserver) {
      var contactObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'characterData') {
            normalizeTextNode(mutation.target);
            return;
          }
          if (mutation.type === 'attributes') {
            normalizeElement(mutation.target);
            return;
          }
          mutation.addedNodes.forEach(normalizeContactDetails);
        });
      });
      contactObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['href', 'title', 'aria-label', 'content', 'value'],
        characterData: true,
        childList: true,
        subtree: true
      });
    }
  })();

  /* Policy page tables */
  document.querySelectorAll('.shopify-policy__body table').forEach(function (table) {
    if (table.parentElement && table.parentElement.classList.contains('policy-table-scroll')) return;
    var wrapper = document.createElement('div');
    wrapper.className = 'policy-table-scroll';
    wrapper.tabIndex = 0;
    wrapper.setAttribute('role', 'region');
    wrapper.setAttribute('aria-label', 'Policy details table');
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });

  /* Vehicle finder anchor */
  if (window.location.hash === '#vehicle-finder') {
    var vehicleFinder = document.getElementById('vehicle-finder');
    if (vehicleFinder) {
      window.setTimeout(function () {
        vehicleFinder.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 200);
    }
  }
})();